import {defineSlotRecipe} from '@chakra-ui/react3'

export default defineSlotRecipe({
    slots: ['button', 'link'],
    base: {
        button: {
            size: 'lg'
        },
        link: {
            width: 'max-content'
        }
    },
    variants: {
        variant: {
            primary: {
                button: {
                    variant: 'primaryFilled'
                }
            },
            secondary: {
                button: {
                    variant: 'secondaryOutline'
                }
            },
            text: {
                link: {
                    variant: 'secondary',
                    underline: true
                }
            }
        }
    }
})
